import { useGetBudgets } from "./budgets";
import { useGetAccounts } from "./accounts";
import { useGetCurrencies } from "./currency";
import { useGetVessels } from "./vessel";
import { useGetVendors } from "./vendor";

export const queryKeys = [
  "accounts",
  "account-detail",
  "budgets",
  "budget-detail",
  "budget-categories",
  "budget-category-detail",
  "budget-sub-categories",
  "currencies",
  "currency-detail",
  "transactions",
  "transactions-by-date-range",
  "vendors",
  "vendor-detail",
  "vessels",
  "vessel-detail",
] as const;

// Queries that are not dependent on each other
export const useGetAllQueriesAtOnce = ({
  enabled = true,
}: {
  enabled?: boolean;
}) => {
  const budgetsQuery = useGetBudgets({ enabled });
  const accountsQuery = useGetAccounts({ enabled });
  const currenciesQuery = useGetCurrencies({ enabled });
  const vesselsQuery = useGetVessels({ enabled });
  const vendorsQuery = useGetVendors({ enabled });

  return {
    budgets: budgetsQuery,
    accounts: accountsQuery,
    currencies: currenciesQuery,
    vessels: vesselsQuery,
    vendors: vendorsQuery,
  };
};
